import { Download, BookOpen } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
export default function AccessAndInstallation() {
  const steps = [{
    title: "Minimally Invasive Focus",
    description: "Receive the latest updates on state-of-the-art neurological technology and recovery techniques for your brain and spine."
  }, {
    title: "Patient as Family Care",
    description: "Experience our foundational philosophy of compassion and respect through direct wellness guidance and supportive messages."
  }, {
    title: "Direct Health Updates",
    description: "Get seamless appointment reminders and clinic alerts directly to your mobile device to stay on track with your recovery journey."
  }];
  return <section data-section-id="150580" id="tcpacompliantsmsoptinform" className="bg-accent text-foreground py-24 relative overflow-hidden" dir="ltr">
      {}
      <div className="absolute top-0 right-0 -translate-y-12 translate-x-1/3 w-96 h-96 bg-primary/5 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 left-0 translate-y-1/3 -translate-x-1/3 w-[30rem] h-[30rem] bg-secondary/5 rounded-full blur-3xl pointer-events-none" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

          {}
          <div className="flex flex-col">
            <h2 className="text-4xl md:text-5xl font-extrabold font-sans text-primary mb-10 tracking-tight leading-tight">
              Join Our Care Circle
            </h2>

            <div className="flex flex-col gap-8 mb-12">
              {steps.map((step, i) => <div key={i} data-index={i} className="flex items-start gap-5 group">
                  <Badge variant="outline" className="w-10 h-10 rounded-full flex items-center justify-center shrink-0 bg-primary/10 text-primary border-primary/20 text-lg font-bold transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
                    {i + 1}
                  </Badge>
                  <div className="flex flex-col gap-1.5 pt-1">
                    <h3 className="text-xl font-semibold text-foreground font-sans">
                      {step.title}
                    </h3>
                    <p className="text-foreground/70 leading-relaxed font-sans">
                      {step.description}
                    </p>
                  </div>
                </div>)}
            </div>

            <div className="flex flex-wrap items-center gap-4">
              <Button size="lg" className="rounded-full px-8 h-14 text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300 bg-primary text-primary-foreground">
                <Download className="size-5" />
                Subscribe Now
              </Button>
              <Button variant="ghost" size="lg" asChild className="rounded-full h-14 px-6 text-foreground/60 hover:text-foreground">
                <Link to="/ConnectPage">
                  <BookOpen className="size-5" />
                  Privacy Policy
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="relative lg:mr-8 mt-12 lg:mt-0">
            {}
            <div className="absolute -inset-4 bg-primary/10 blur-3xl rounded-[3rem] opacity-50" />

            <Card className="relative bg-card/40 backdrop-blur-xl border-border/50 overflow-hidden rounded-[2.5rem] shadow-2xl p-2">
              <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent pointer-events-none" />
              <AspectRatio ratio={4 / 3} className="bg-muted rounded-[2rem] overflow-hidden border border-border/20">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603830/img/image_18rwwbk8.png" alt="NeuroFamily Compassionate Care" className="w-full h-full object-cover transition-transform duration-700 hover:scale-105" />
              </AspectRatio>
            </Card>

            {}
            <div className="absolute -top-6 -right-6 bg-background border border-border shadow-lg rounded-2xl p-4 flex items-center gap-3 animate-bounce" style={{
            animationDuration: '3s'
          }}>
              <div className="w-3 h-3 rounded-full bg-primary animate-pulse" />
              <span className="text-sm font-medium text-foreground">HIPAA Compliant</span>
            </div>
          </div>

        </div>
      </div>
    </section>;
}